import LoyaltyIcon from '@mui/icons-material/Loyalty'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import I18n from 'i18n-js'
import { makeStyles } from 'tss-react/mui'

import LegacySvg from '../shared/LegacySvg'

import SuggestBrandsForm, { SuggestBrandsFormProps } from './SuggestBrandsForm'

const useStyles = makeStyles()((theme) => ({
  paperBorder: {
    overflow: 'hidden',
    background: '#17bcc8',
  },
  blurbText: {
    color: 'white',
  },
  heartIcon: {
    fontSize: 70,
  },
  blurbContainer: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  formStyling: {
    background: theme.palette.background.paper,
    padding: theme.spacing(5),
    height: '100%',
  },
}))

interface SuggestBrandsCardProps
  extends Pick<SuggestBrandsFormProps, 'onDidSubmit'> {
  topContent?: React.ReactNode
}

const SuggestBrandsCard: React.FC<
  React.PropsWithChildren<SuggestBrandsCardProps>
> = (props) => {
  const { classes } = useStyles()

  return (
    <Paper className={classes.paperBorder} elevation={2}>
      <Grid alignItems="stretch" container justifyContent="center" spacing={5}>
        <Grid item sm={6}>
          <Box className={classes.blurbContainer}>
            <Typography
              align="center"
              className={classes.blurbText}
              variant="h4"
            >
              {I18n.t('manageBrands.suggestBrandsPage.iWould')} <br />
              <LoyaltyIcon className={classes.heartIcon} /> <br />
              {I18n.t(
                'manageBrands.suggestBrandsPage.itIfYourBrandWas',
              )} <br /> {I18n.t('manageBrands.suggestBrandsPage.onThePlatform')}
            </Typography>
            <LegacySvg symbol={'refer'} width={'auto'} />
          </Box>
        </Grid>
        <Grid item sm={6}>
          <div className={classes.formStyling}>
            {props.topContent}
            <SuggestBrandsForm onDidSubmit={props.onDidSubmit} />
          </div>
        </Grid>
      </Grid>
    </Paper>
  )
}

export default SuggestBrandsCard
